/* eslint-disable */

const NoestStatesPricing = [
  {
    wilaya_code: "01",
    name: "أدرار",
    price: 1500,
    stopdesk: "Stop Desk أدرار",
    pricestopdesk: 700,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "02",
    name: "الشلف",
    price: 800,
    stopdesk: "Stop Desk الشلف",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "03",
    name: "الأغواط",
    price: 1000,
    stopdesk: "Stop Desk الأغواط",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "04",
    name: "أم البواقي",
    price: 800,
    stopdesk: "Stop Desk أم البواقي",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "05",
    name: "باتنة",
    price: 800,
    stopdesk: "Stop Desk باتنة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "06",
    name: "بجاية",
    price: 800,
    stopdesk: "Stop Desk بجاية",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "07",
    name: "بسكرة",
    price: 1000,
    stopdesk: "Stop Desk بسكرة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "08",
    name: "بشار",
    price: 1200,
    stopdesk: "Stop Desk بشار",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "09",
    name: "البليدة",
    price: 600,
    stopdesk: "Stop Desk البليدة",
    pricestopdesk: 300,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "10",
    name: "البويرة",
    price: 650,
    stopdesk: "Stop Desk البويرة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "11",
    name: "تمنراست",
    price: 2000,
    stopdesk: "Stop Desk تمنراست",
    pricestopdesk: 1000,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "12",
    name: "تبسة",
    price: 900,
    stopdesk: "Stop Desk تبسة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "13",
    name: "تلمسان",
    price: 800,
    stopdesk: "Stop Desk تلمسان",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "14",
    name: "تيارت",
    price: 900,
    stopdesk: "Stop Desk تيارت",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "15",
    name: "تيزي وزو",
    price: 700,
    stopdesk: "Stop Desk تيزي وزو",
    pricestopdesk: 300,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "16",
    name: "الجزائر",
    price: 650,
    stopdesk: "Stop Desk الجزائر",
    pricestopdesk: 300,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "17",
    name: "الجلفة",
    price: 1000,
    stopdesk: "Stop Desk الجلفة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "18",
    name: "جيجل",
    price: 850,
    stopdesk: "Stop Desk جيجل",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "19",
    name: "سطيف",
    price: 800,
    stopdesk: "Stop Desk سطيف",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "20",
    name: "سعيدة",
    price: 800,
    stopdesk: "Stop Desk سعيدة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "21",
    name: "سكيكدة",
    price: 800,
    stopdesk: "Stop Desk سكيكدة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "22",
    name: "سيدي بلعباس",
    price: 800,
    stopdesk: "Stop Desk سيدي بلعباس",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "23",
    name: "عنابة",
    price: 800,
    stopdesk: "Stop Desk عنابة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "24",
    name: "قالمة",
    price: 900,
    stopdesk: "Stop Desk قالمة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "25",
    name: "قسنطينة",
    price: 800,
    stopdesk: "Stop Desk قسنطينة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "26",
    name: "المدية",
    price: 600,
    stopdesk: "Stop Desk المدية",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "27",
    name: "مستغانم",
    price: 800,
    stopdesk: "Stop Desk مستغانم",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "28",
    name: "المسيلة",
    price: 800,
    stopdesk: "Stop Desk المسيلة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "29",
    name: "معسكر",
    price: 800,
    stopdesk: "Stop Desk معسكر",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "30",
    name: "ورقلة",
    price: 1000,
    stopdesk: "Stop Desk ورقلة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "31",
    name: "وهران",
    price: 800,
    stopdesk: "Stop Desk وهران",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "32",
    name: "البيض",
    price: 1200,
    stopdesk: "Stop Desk البيض",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "33",
    name: "إليزي",
    price: 1500,
    stopdesk: "Stop Desk إليزي",
    pricestopdesk: 700,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "34",
    name: "برج بوعريريج",
    price: 800,
    stopdesk: "Stop Desk برج بوعريريج",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "35",
    name: "بومرداس",
    price: 600,
    stopdesk: "Stop Desk بومرداس",
    pricestopdesk: 300,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "36",
    name: "الطارف",
    price: 900,
    stopdesk: "Stop Desk الطارف",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "37",
    name: "تندوف",
    price: 1700,
    stopdesk: "Stop Desk تندوف",
    pricestopdesk: 850,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "38",
    name: "تيسمسيلت",
    price: 800,
    stopdesk: "Stop Desk تيسمسيلت",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "39",
    name: "الوادي",
    price: 1000,
    stopdesk: "Stop Desk الوادي",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "40",
    name: "خنشلة",
    price: 900,
    stopdesk: "Stop Desk خنشلة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "41",
    name: "سوق أهراس",
    price: 900,
    stopdesk: "Stop Desk سوق أهراس",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "42",
    name: "تيبازة",
    price: 600,
    stopdesk: "Stop Desk تيبازة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "43",
    name: "ميلة",
    price: 800,
    stopdesk: "Stop Desk ميلة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "44",
    name: "عين الدفلى",
    price: 800,
    stopdesk: "Stop Desk عين الدفلى",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "45",
    name: "النعامة",
    price: 1200,
    stopdesk: "Stop Desk النعامة",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "46",
    name: "عين تموشنت",
    price: 800,
    stopdesk: "Stop Desk عين تموشنت",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "47",
    name: "غرداية",
    price: 1000,
    stopdesk: "Stop Desk غرداية",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "48",
    name: "غليزان",
    price: 800,
    stopdesk: "Stop Desk غليزان",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "49",
    name: "تيميمون",
    price: 1500,
    stopdesk: "Stop Desk تيميمون",
    pricestopdesk: 700,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "50",
    name: "برج باجي مختار",
    price: 1500,
    stopdesk: "Stop Desk برج باجي مختار",
    pricestopdesk: 700,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "51",
    name: "أولاد جلال",
    price: 900,
    stopdesk: "Stop Desk أولاد جلال",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "52",
    name: "بني عباس",
    price: 1200,
    stopdesk: "Stop Desk بني عباس",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "53",
    name: "عين صالح",
    price: 1850,
    stopdesk: "Stop Desk عين صالح",
    pricestopdesk: 950,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "54",
    name: "عين قزام",
    price: 2000,
    stopdesk: "Stop Desk عين قزام",
    pricestopdesk: 1000,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "55",
    name: "تقرت",
    price: 900,
    stopdesk: "Stop Desk تقرت",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "56",
    name: "جانت",
    price: 1700,
    stopdesk: "Stop Desk جانت",
    pricestopdesk: 850,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "57",
    name: "المغير",
    price: 1000,
    stopdesk: "Stop Desk المغير",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "58",
    name: "المنيعة",
    price: 1000,
    stopdesk: "Stop Desk المنيعة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
];

export default NoestStatesPricing;
